import Head from 'next/head';
import React from 'react';

import { useAuth } from '../../context/AuthContext';
import { sendbirdClient } from '../../lib/sendbird/sendbirdClient';
import { useUnreadMessageCount } from '../../utils/sendbird';

interface Props {
  title: string;
}

export const MessageCountHead: React.FC<Props> = ({ title }) => {
  const { currentUser } = useAuth();
  const unreadMessageCount = useUnreadMessageCount(
    currentUser?.applicant?.id,
    sendbirdClient,
  );

  return (
    <Head>
      <title key="title">{`${
        unreadMessageCount ? `(${unreadMessageCount}) ` : ''
      }${title}`}</title>
    </Head>
  );
};
